import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=33a12156&scoped=true"
import script from "./VerifyCode.vue?vue&type=script&lang=js"
export * from "./VerifyCode.vue?vue&type=script&lang=js"
import style0 from "./VerifyCode.vue?vue&type=style&index=0&id=33a12156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a12156",
  null
  
)

export default component.exports